import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import App from './pages/App';
// import store from './redux/store';

import { Provider } from 'react-redux'
import { store, persistor } from 'redux/store'
import { PersistGate } from 'redux-persist/integration/react'

import { Buffer } from 'buffer';
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router>
        <PersistGate loading={null} persistor={persistor}>
            <Provider store={store}>
            <App />
        </Provider>
    </PersistGate>
    </Router >
);

// store.subscribe(()=>{
//     root.render(
//         <Router>
//             <App/>
//         </Router>
//     );
// })


